export default __webpack_public_path__ + "static/media/dailymotion.dd6b998d.svg";